import { parseTemplate } from 'url-template';

export const createDownloadUrl = (fileId: string, fileName: string, accessToken: string) => {
	const url = parseTemplate('download/{fileId}/{fileName}{?accessToken}');
	return url.expand({ fileId, fileName, accessToken });
};
